module.exports = __webpack_public_path__ + "img/step1.bd2b0584.png";